<div class="list-container">
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Title" class="table-header-title">{{ 'specialOffers.specialOfferList.title' | translate }}</th>

                    <th id="Start-End-Date" class="table-header-title">{{ 'specialOffers.specialOfferList.startEndDate' | translate }}</th>

                    <th id="Dealer" class="table-header-title">{{ 'specialOffers.specialOfferList.dealer' | translate }}</th>

                    <th id="Industry" class="table-header-title">{{ 'specialOffers.specialOfferList.industry' | translate }}</th>

                    <th id="Brand" class="table-header-title">{{ 'specialOffers.specialOfferList.brand' | translate }}</th>

                    <th id="Leads" class="table-header-title">{{ 'specialOffers.specialOfferList.leads' | translate }}</th>

                    <th id="Status" class="table-header-title">
                        <div class="d-flex justify-content-center">
                            {{ 'specialOffers.specialOfferList.status' | translate }}
                            <i class="app-icon icon icon-info-circle-fill info-tooltip-trigger ms-1 align-self-center" 
                                [ngbTooltip]="requiredInfoTooltip" tooltipClass="opacity-100">
                            </i> 
                        </div>
                    </th>

                    <th id="Actions"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let specialOffer of specialOffers">
                    <tr class="row-container ccc ccc-table-row ccc-hover" role="button"
                        (click)="navigateToDetailHandler(specialOffer.specialOfferId)">
                        <td HJSuppress id="Title" class="column-content">
                            {{ specialOffer.title }}
                        </td>

                        <td HJSuppress id="Start-End-Date" class="column-content">
                            {{ specialOffer.startDate | localizedDate }} - {{ specialOffer.endDate | localizedDate}}
                        </td>

                        <td HJSuppress id="Dealer" class="column-content">
                            {{ specialOffer.dealerName }}
                        </td>

                        <td HJSuppress id="Industry" class="column-content text-secondary">
                            {{ specialOffer.campaignType }}
                        </td>

                        <td HJSuppress id="Brand" class="column-content text-secondary">
                            {{  specialOffer.manufacturerName  }}
                        </td>

                        <td HJSuppress id="Leads" class="column-content ">
                            <span class="text-primary">{{ specialOffer.leadsCount}}</span> / <span class="text-secondary"> {{specialOffer.viewersCount}} </span>
                        </td>
                        
                        <td HJSuppress id="Status" class="column-content">
                            @switch (specialOffer.status) {
                                @case (specialOfferStatus.ONGOING) {
                                    <div class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                        {{'specialOffers.statusMessage.ongoing' | translate}}
                                    </div>
                                }
                                @case (specialOfferStatus.UPCOMING) {
                                    <div class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                        {{'specialOffers.statusMessage.upcoming' | translate}}
                                    </div>
                                }
                                @case (specialOfferStatus.ENDED) {
                                    <div class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                        {{'specialOffers.statusMessage.ended' | translate}}
                                    </div>
                                }
                                @case (specialOfferStatus.DRAFT) {
                                    <div class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                        {{'specialOffers.statusMessage.draft' | translate}}
                                    </div>
                                }
                            }
                        </td>
                        <td HJSuppress id="Status" class="column-content">
                            <div 
                                class="d-flex justify-content-center" 
                                role="button">
                                <div class="d-flex justify-content-center position-relative mx-2"
                                    (click)="openPopOver($event)">
                                    <i class="app-icon icon icon-ellipsis-vertical"
                                        [ngbPopover]="actionBox"
                                        container="body"
                                        popoverClass="actions-popover"
                                        triggers="click"
                                        [popoverContext]="{specialOffer : specialOffer, popOver:popOver}"
                                        #popOver="ngbPopover"
                                        autoClose="outside">
                                    </i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>

<ng-template #actionBox #popContent let-specialOffer="specialOffer" let-popOver="popOver">
    <div class="d-flex flex-column align-items-start">

        <button class="btn delete-btn p-2"
            (click)="navigateToDetailHandler(specialOffer.specialOfferId)">
            <i class="app-icon icon icon-edit grey-icon icon-lg me-2"></i>
            {{ 'specialOffers.actions.edit' | translate }}
        </button>

        <button class="btn delete-btn p-2"
            (click)="duplicateCampaign(specialOffer); popOver.close()"
            *ngIf="specialOffer.status === specialOfferStatus.ENDED">
            <i class="app-icon icon icon-copy grey-icon icon-lg me-2"></i>
            {{ 'specialOffers.actions.duplicate' | translate }}
        </button>

        <button class="btn delete-btn p-2 text-danger"
            *ngIf="specialOffer.status === specialOfferStatus.ONGOING"
            (click)="stopCampaign(specialOffer); popOver.close()">
            <i class="app-icon icon icon-clock icon-lg me-2"></i>
            {{ 'specialOffers.actions.stop' | translate }}
        </button>

        <button class="btn delete-btn p-2 text-danger" 
            (click)="deleteCampaign(specialOffer); popOver.close()"
            *ngIf="specialOffer.status === specialOfferStatus.DRAFT">
            <i class="app-icon icon icon-delete icon-lg me-2"></i>
            {{ 'specialOffers.actions.delete' | translate }}
        </button>

    </div>
</ng-template>

<ng-template #requiredInfoTooltip >
    {{ 'specialOffers.specialOfferList.infoTooltip' | translate }}
</ng-template>
